import { useAuthStore } from '~/stores/auth.store';
import { useSiteStore } from '~/stores/site.store';
import { useServices } from '~/composables/useServices';
import { globalKeys } from 'assets/data/global-keys';
import { useEnvironment } from '~/composables/useStates/useEnvironment';
import { setBrandColors } from '~/utilities/ui-utilities';
import { uuid } from '~/utilities/uuid';

export default defineNuxtPlugin({
  name: 'init-client',
  parallel: true,
  async setup() {
    const environment = useEnvironment();
    const { $configService } = useServices();
    const { setLocaleCode } = useLocaleUtils();
    const siteStore = useSiteStore();
    siteStore.setRegion(environment?.value?.regionConfigs?.countryCode);
    setLocaleCode(environment?.value?.regionConfigs?.presetLocale);
    await $configService.fetchFullConfig();
  },
  hooks: {
    async 'app:created'(nuxt) {
      const siteStore = useSiteStore();
      const { $storageService } = useServices(nuxt.$nuxt);

      const deviceId = $storageService.getLocalStorage<string | null>({
        key: globalKeys.siteConfigKeys.deviceIdentifier,
      });

      const route = useRoute();
      const currentBtag = $storageService.getCookie({
        key: globalKeys.marketingKeys.bannerTag,
      });
      if (!currentBtag && !!route.query?.btag) {
        $storageService.setCookie({
          key: globalKeys.marketingKeys.bannerTag,
          data: route.query?.btag,
          expiry: 0,
        });
      }
      if (!!currentBtag && !!route.query?.btag) {
        $storageService.setCookie({
          key: globalKeys.marketingKeys.referrerBannerTag,
          data: route.query?.btag,
          expiry: 0,
        });
      }

      siteStore.setWebview(
        !!route.query?.isNativeApp || !!route.query?.webview,
      );
      if (!deviceId) {
        $storageService.setLocalStorage({
          key: globalKeys.siteConfigKeys.deviceIdentifier,
          data: uuid(),
        });
      }
    },
    'app:error'(err) {
      console.error({ type: 'app error', err });
    },
    'vue:error'(err, instance, info) {
      console.error({ type: 'vue error', err, instance, info });
    },
    async 'app:mounted'(nuxt) {
      const { $marketingService, $gameService } = useServices();
      const siteStore = useSiteStore(nuxt.$nuxt.$pinia);
      const auth = useAuthStore(nuxt.$nuxt.$pinia);

      if (!siteStore?.isWebview) {
        if (siteStore.getFeatureFlags.get('website.toastmessages')) {
          await $marketingService.fetchToasts();
        }
        await $gameService.fetchBuildVersion();
        await auth.initAuth();
      }
      setBrandColors();
    },
  },
  dependsOn: ['api'],
});
